import { render } from "./UserAwards.vue?vue&type=template&id=46f600b0"
import script from "./UserAwards.vue?vue&type=script&lang=js"
export * from "./UserAwards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__